// utils/CartLogic.js

import { getProductName, getProductImageUrl } from './AppHelpers';

// NOTE: TAX_RATE defined in App.js is imported here if it needs to be dynamic, 
// otherwise we use the static value from App.js's current context.
const TAX_RATE = 0.00; 

export const enrichCartItems = (cartItems, newProducts = [], productDefinitionMap) => {
    const immediateProductMap = new Map();
    if (newProducts && newProducts.length > 0) {
        newProducts.forEach(p => {
            if (p && p.sku != null) {
                immediateProductMap.set(String(p.sku), p);
            }
        });
    }

    const combinedMap = new Map(productDefinitionMap);

    if (!cartItems) return [];

    return cartItems.map(item => {
        if (!item || item.sku == null) return item;
        
        const itemSkuString = String(item.sku);
        const originalProduct = immediateProductMap.get(itemSkuString) || combinedMap.get(itemSkuString);

        if (originalProduct) {
            return {
                ...item,
                name: getProductName(originalProduct),
                image: getProductImageUrl(originalProduct),
                price: Number(item.sellingPrice || item.price || originalProduct.sellingPrice || originalProduct.price || 0)
            };
        } else {
            return {
                ...item,
                name: item.name || item.productName || "Product " + item.sku,
                image: item.image || `https://via.placeholder.com/300x300.png?text=${item.sku}`,
                price: Number(item.price || item.sellingPrice || 0)
            };
        }
    });
};

export const calculateCart = (items) => {
    const sanitizedItems = items.map(item => {
        const qty = Number(item.quantity);
        const price = Number(item.sellingPrice || item.price || 0);
        return {
            ...item,
            quantity: isNaN(qty) ? 0 : qty,
            price: isNaN(price) ? 0 : price
        };
    });

    const validItems = sanitizedItems.filter(item => item && item.quantity > 0);

    const newItems = validItems.map(item => ({
        ...item,
        subtotal: item.price * item.quantity
    }));

    const subtotal = newItems.reduce((acc, item) => acc + item.subtotal, 0);
    const tax = subtotal * TAX_RATE;
    const total = subtotal + tax;

    return { items: newItems, subtotal, tax, total };
};

export const updateProductDefinitionMap = (products, setProductDefinitionMap) => {
    if (!products || products.length === 0) return;
    
    setProductDefinitionMap(prevMap => {
        const newMap = new Map(prevMap);
        products.forEach(p => {
            if (p && p.sku != null) {
                newMap.set(String(p.sku), p);
            }
        });
        return newMap;
    });
};